import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_stationery_writing: FaireCategoryEntity = {
  token: "catalog_cat_stationery-writing",
  type: "category",
  name: "Stationery & writing",
  count: 13,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
